export default __webpack_public_path__ + "static/media/Abdelrahman-resume.471340c2.pdf";